/**
 * Marker Template
 * @param {obj} data - property data/json
 */
function markerTmpl(data) {
  var url = encodeURIComponent(data.address);
  return "<article class=\"marker-box\">\n\t<div class=\"marker-box__wrap\">\n\t  <div class=\"marker-box__grid\">\n\t\t<div class=\"marker-box__main\">\n\t\t  <span class=\"marker-box__title\">".concat(data.title, "</span>\n\t\t  <address class=\"marker-box__address\">\n\t\t\t<span class=\"marker-box__address\">").concat(data.address, "</span>\n\t\t  </address>\n\t\t  <a class=\"marker-box__btn btn-line\" href=\"https://www.google.com/maps/place/").concat(url, "/\" target=\"_blank\">Get Directions</a>\n\t\t</div>\n\t  </div>\n\t</div>\n  </article>");
}

export default markerTmpl;